<template>
    <div class="content">
        <div class="description">
            <p>Наша жизнь полна стереотипов. Мы живем с ними и не подозреваем, как сильно они влияют на нас</p>
            <p>Как избавиться от стереотипов?</p>
            <p>
                Первый шаг - это найти свои установки, вытащить их наружу.
                Второй шаг - познакомиться с другой точкой зрения
            </p>
            <p>Попробуйте прямо сейчас! Выбирайте интересную сферу и отмечайте стереотипы, которые присутствуют в вашей жизни</p>
        </div>
        <CategoriesList />
    </div>
</template>

<script>
    // @ is an alias to /src
    import CategoriesList from '@/components/CategoriesList.vue';

    export default {
        name: 'Home',
        components: {
            CategoriesList
        }
    }
</script>
